module.exports = __webpack_public_path__ + "img/coupon_160.5c228bb0.png";